<template>
  <div id="index" v-cloak v-visibility-change="change">

    <div class="center" v-show="is_loading">
      <header class="flex_center m_header">
        <i class="esc" @click="goBackward"><img src="@/assets/img/fanhi3111.png" alt=""></i>
        <!-- <h4 class="header_title clamp1">{{details.name}}</h4> -->
      </header>
      <!-- 欢迎标语 -->
      <div class="welcome">
        欢迎来到直播间
      </div>
      <!-- 手机端 -->
      <section class="min_center">
        <!-- 头部 -->
        <!-- <div class="video_left_top flex_between">
          <div class="video_title flex_start">
            <div class="title_name flex_between">
              <div class="title_h5">{{details.name}}</div>
              <div class="flex_start title_tag"></div>
            </div>
          </div>
          <div class="focus flex_center" @click="maskShowc">
            <img src="@/assets/img/focus.png" alt=" ">
            关注
          </div>
        </div> -->
        <!-- 视频区 -->
        <div class="min_live_div">
          <video id="myVideo" v-if="!maskShow" class="video-js vjs-default-skin vjs-big-play-centered"
            controls="controls" preload="auto" :src="record_url" autoplay="auto" data-setup="{}" x5-playsinline=""
            name="media" playsinline="true" webkit-playsinline="true" x5-video-player-type="h5-page"
            x5-video-player-fullscreen="true">
            <source src="http://livedown.mlscd.cn/c7/d7.m3u8?auth_key=1589724076-0-0-e31d8b6df1c28ed57a755893e64a08b3"
              type="application/x-mpegURL">
            <!-- <source :src="record_url" type="application/x-mpegURL"> -->
            <!-- <source :src="record_url" type="video/ogg"> -->
            <!-- <source :src="record_url" type="video/mp4"> -->
            <!-- <source :src="record_url" type="video/webm"> -->
            <!-- <source :src="record_url" type="video/flv">您的浏览器版本偏低，请升级最新版！！！ -->
          </video>
          <div class="roomVideo_bg" v-if="show_tiem == 1 && details.cover&&is_loading"
            :style="{backgroundImage:'url('+details.cover+')'}">
          </div>
          <div class="roomVideo_bg" v-if="show_tiem == 1 && !details.cover &&is_loading"
            style="backgroundImage:url('http://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/051719600a90047693680f30867b8042.jpeg')">
          </div>
          <span id="seeNum" class="flex_start">
            <i>
              <img src="@/assets/img/yan.png" alt="">
            </i>
            {{thousandBitSee}}
          </span>
        </div>
        <!-- <div class="showtime ">开播时间：{{start_time}} </div>
		<div class="min_img " v-if="details.mobile_image ">
			<img :src="IMG_URL + details.mobile_image " alt=" ">
		</div> -->
        <!-- 直播banner -->
        <div class="video_banner flex_center" @click.stop="publicFun">
          <div class="announcement_bg" v-if="!is_time">
            <img src="@/assets/img/announcement_bg.png" alt="">
            <h4 id="msgT" class="msgText count flex_center" v-html="msg"></h4>
          </div>
          <div class="swiper-container videBanner" v-else-if="details.mobile_image">
            <div class="swiper-wrapper">
              <div class="swiper-slide flex_center" v-for='(liem,index) in details.mobile_image'>
                <img :src="IMG_URL+liem" alt="">
              </div>

            </div>
          </div>
          <div class="announcement_bg" v-else-if="is_time">
            <img src="@/assets/img/announcement_bg.png" al.t="">
            <h4 class="msgText flex_center" v-if="show_tiem == 1">直播结束</h4>
            <h4 class="msgText flex_center" v-else-if="show_tiem == 0">直播中</h4>
          </div>
        </div>

        <div class="min_text_div " :class="{'containers_box':min_head_index >1}">
          <div class="min_text_head flex_start">
            <div class="min_head_tag flex_center" @click="min_head_index = 1" :class="{'selected':min_head_index == 1}">
              聊天
            </div>
            <div class="min_head_tag flex_center" @click="min_head_index = 3" :class="{'selected':min_head_index == 3}">
              精选
            </div>
            <div class="min_head_tag flex_center" @click="min_head_index = 2" :class="{'selected':min_head_index == 2}">
              介绍
            </div>
            <div class="min_head_tag flex_center" @click="min_head_index = 5" :class="{'selected':min_head_index == 5}">
              推荐
            </div>
            <div class="min_head_tag flex_center" @click="min_head_index = 4" :class="{'selected':min_head_index == 4}">
              合作
            </div>
          


            <div class="focus flex_center" @click="maskShare" v-if="is_app">
              <img src="@/assets/img/share_icon.png" alt="">
              分享
            </div>
            <!-- <div class="focus flex_center" @click="maskShowc" v-else>
              <img src="@/assets/img/focus.png" alt=" ">
              关注
            </div> -->
          </div>
          <!-- 签到按钮 -->
          <div class="sign_button flex_center" @click="signFun(1)">
            <i class="flex_center"><img src="@/assets/img/integralT.png" alt=""></i>
            签到
          </div>
          <!-- 幸运观众 -->
          <div class="lucky_swiper swiper-container" v-if="viewers.length>0">
            <div class="swiper-wrapper">
              <div class="swiper-slide flex_center" v-for="liem in viewers">
                恭喜 “<i><img :src="liem.image" alt=""></i><span>{{liem.name}}</span>” 获取幸运观众
              </div>
            </div>
          </div>
          <!-- 聊天 -->
          <div class="min_text_center min_chat_ul" id="new_message" v-if="min_head_index == 1">
            <div class="min_chat_li discuss_li" v-for="liem in chatArr" :class="{'red':liem.member_id == 0}">
              <div>
                <div class="chat_li_top flex_start">
                  <!-- <i><img :src="liem.headimg" alt=""></i> -->
                  <i><img
                      :src="liem.image?liem.image:'https://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/logo.jpg'"
                      alt=""></i>
                  <span class="chat_head_name">{{liem.name}}</span>
                  <span class="chat_head_time">
                    {{liem.time}}
                  </span>
                </div>
                <div class="chat_li_center" v-if="liem.type == '1'" v-html="liem.center">
                </div>
                <div class="chat_li_center li_r_img" v-if="liem.type == '2'">
                  <img :src="liem.center+'?x-oss-process=image/resize,m_lfit,w_289'" alt="">
                </div>
              </div>
              <!-- <div v-if="liem.id == 0" class="right">
						<div class="chat_li_top flex_end">
							<i><img :src="liem.image?liem.image:'https://anesthesiavision.oss-cn-shanghai.aliyuncs.com/img/logo.jpg'" alt=""></i>
							<span class="chat_head_name">{{liem.name}}</span>
							<span class="chat_head_time">
							{{liem.time}}
						</span>
						</div>
						<div class="chat_li_center" v-html="liem.center">
						</div>
					</div> -->
            </div>
          </div>
          <!-- 推荐 -->

          <div class="min_text_center recommended_ul" v-if="min_head_index == 5">
            <div class="recommended_li flex_between" v-for="liem in recommendArr" :class="{'red':liem.member_id == 0}"
              @click.stop="linkPage(liem)">
              <i class="recommended_li_img">
                <img v-if="liem.cover" :src="liem.cover" alt="">
                <img v-else src="@/assets/img/tool.jpg" alt="">
              </i>
              <div class="recommended_text flex_around">
                <div class="li_title">{{liem.name}}</div>
                <div class="li_time flex_start">
                  <i><img src="@/assets/img/time.png" alt=""></i>
                  开播时间：{{liem.start_time}}
                </div>
              </div>
            </div>
          </div>
          <!-- 介绍 -->
          <div class="min_text_center tool_div" v-if="min_head_index == 2" >
            <div v-if="details.content" v-html="details.content"></div>
             <div v-else class="claloadding">
            <div>
              <img
                src="@/assets/img/kkry_pc.gif"
                alt=""
              >
            </div>
            <div>空空如也</div>
          </div>
          </div>
          <!-- 日程 -->
          <div class="min_text_center tool_div" v-if="min_head_index == 3">
            <!-- <h4 class="discuss_title">精品留言</h4> -->
            <div class="discuss_center">
              <div class="mess_recomm_li" v-for="(liem,index) in recomm_ul" :key="index">
                <h6 class="flex_start"><i><img :src="liem.image" alt=""></i>{{liem.name}}</h6>
                <div class="mess_recomm_li_cetnter" v-if="liem.type == 1" v-html="liem.center"></div>
                <div class="mess_recomm_li_cetnter mess_recomm_img" v-if="liem.type == 2">
                  <img :src="liem.center" alt="">
                </div>
              </div>
            </div>
            <!-- <h4 class="discuss_title heng">提问</h4> -->
            <div class="discuss_center" v-html="details.live_date"></div>
          </div>
          <!-- 合作 -->
          <div class="min_text_center tool_div" v-if="min_head_index == 4" v-html="details.cooperation">
          </div>
          <!-- 输入框 -->
          <div class="chat_input" v-show="min_head_index == 1">
            <!-- 礼物列表 -->
            <div class="flex_around gift_list">
              <!-- <i @click="giftAdd('T')"><img src="@/assets/img/tu3.png" alt=""></i>
              <i @click="giftAdd('A')"><img src="@/assets/img/tu2.png" alt=""></i>
              <i @click="giftAdd('B')"><img src="@/assets/img/tu4.png" alt=""></i>
              <i @click="giftAdd('C')"><img src="@/assets/img/tu1.png" alt=""></i>
              <i @click="giftAdd('D')"><img src="@/assets/img/tu6.png" alt=""></i> -->

              <div class="flex_center gift_div swiper-container ">
                <div class="gift_ul swiper-wrapper">
                  <i class="swiper_item swiper-slide" @click="giftAdd('T')"><img src="@/assets/img/tu3.png" alt=""></i>
                  <i class="swiper_item swiper-slide" @click="giftAdd('G')"><img src="@/assets/img/tu12.png" alt=""></i>
                  <i class="swiper_item swiper-slide" @click="giftAdd('D')"><img src="@/assets/img/tu14.png" alt=""></i>
                  <i class="swiper_item swiper-slide" @click="giftAdd('F')"><img src="@/assets/img/tu11.png" alt=""></i>
                  <i class="swiper_item swiper-slide" @click="giftAdd('E')"><img src="@/assets/img/tu10.png" alt=""></i>
                  <!-- <i class="swiper_item swiper-slide" @click="giftAdd('A')"><img src="@/assets/img/tu2.png"
                    alt=""></i>
                <i class="swiper_item swiper-slide" @click="giftAdd('B')"><img src="@/assets/img/tu4.png"
                    alt=""></i> -->
                </div>
              </div>
            </div>
            <!-- 发送消息 -->
            <div class="text_content">
              <div class="tools-box">
                <div class="operator-box-btn flex_between">
                  <span class="inp_img_box gift_icon" @click="giftAccording">
                    <img src="@/assets/img/gift.png" alt="" srcset="">
                  </span>
                  <div class="give_box flex_center">
                    <i class="flex_center give" :class="{'giveLike':is_give == true}" @click="goods"
                      @mousedown.stop="giveFun">
                      <img id="btnT" src="@/assets/img/bai_zan.png" alt="">
                    </i>
                    <span>{{thousandBitSeparator}}</span>
                  </div>
                  <div class="submit flex_center">
                    <span class="face-icon flex_center">
                      <img src="@/assets/img/smilingT.png" alt="">
                    </span>
                    <input @keydown="bayFun" @click="inputCilick" @focus="is_input = true" @blur="inputBlur"
                      class="text" placeholder="请输入...">
                    <span class="inp_img_box flex_center" @click="upImgFun">
                      <input type="file" class="inp_img" @change="handleChange" id="imgInp" ref="inputer" multiple
                        accept="image/*">
                      <img src="@/assets/img/tupianT.png" alt="" srcset="">
                    </span>

                  </div>
                  <div class="submit-btn" @click.stop="out"><input type="button" value="发送" /></div>



                </div>
              </div>
            </div>
          </div>


          <!-- 更多消息 -->
          <!-- <div class="more_news flex_center"
          v-if="!is_bottom && min_head_index==1" @click="rollFun">
            <img src="@/assets/img/gengduo.png" alt="">
            更多消息
          </div> -->
          <!-- 礼物动态区 -->
          <div class="demoCanvasT demoCanvas">
            <GiftT :gift_arrT="gift_arrT" ref="giftT" @giftFunT="giftFunT">
            </GiftT>
          </div>
          <div class="demoCanvasA demoCanvas">
            <GiftA :gift_arrA="gift_arrA" ref="giftA" @giftFunA="giftFunA">
            </GiftA>
          </div>
          <div class="demoCanvasB demoCanvas">
            <GiftB :gift_arrB="gift_arrB" ref="giftB" @giftFunB="giftFunB">
            </GiftB>
          </div>
          <div class="demoCanvasC demoCanvas">
            <GiftC :gift_arrC="gift_arrC" ref="giftC" @giftFunC="giftFunC">
            </GiftC>
          </div>
          <div class="demoCanvasD demoCanvas">
            <GiftD :gift_arrD="gift_arrD" ref="giftD" @giftFunD="giftFunD">
            </GiftD>
          </div>
          <div class="demoCanvasE demoCanvas">
            <GiftE :gift_arrE="gift_arrE" ref="giftE" @giftFunE="giftFunE">
            </GiftE>
          </div>
          <div class="demoCanvasF demoCanvas">
            <GiftF :gift_arrF="gift_arrF" ref="giftF" @giftFunF="giftFunF">
            </GiftF>
          </div>
          <div class="demoCanvasG demoCanvas">
            <GiftG :gift_arrG="gift_arrG" ref="giftG" @giftFunG="giftFunG">
            </GiftG>
          </div>
          <!-- 用户进入提示 -->
          <div class="user_enter">
            <div class="user_enter_li flex_center" :style="{color: color_arr[index<5?index:(index*1)%5]}"
              v-for="(liem,index) in user_enterArr" :key="index">
              <i class="user_enter_portrait flex_center" :style="{backgroundImage:'url('+liem.image+')'}">
              </i>
              {{liem.text}}</div>

            <div class="user_enter_li flex_center gift_li" :style="{backgroundColor: color_arr[index<5?index:index%5]}"
              v-for="(liem,index) in gift_user" :key="index">
              <i class="user_enter_portrait flex_center" :style="{backgroundImage:'url('+liem.image+')'}">
              </i>
              <span>{{liem.text}}</span></div>
          </div>
        </div>
      </section>
      <!-- 签到 -->
      <SignIn :is_sign="is_sign" :live_id="id" @signFun="signFun"></SignIn>
      <!-- 问答卷 -->
      <AnswerPopup :is_answerPopup="is_answerPopup" @answerFun="answerFun" :options_id="options_id" :question="question"
        @popupFun="popupFun"></AnswerPopup>

      <footer class="foot flex_center">
        Copyright 2016 麻醉眼界
        <a href="http://beian.miit.gov.cn/" target="_blank">沪ICP备16022724号-1</a>
      </footer>
      <div class="mask" v-if="maskShow" @click="maskShowc">
        <img src="@/assets/img/cuo.png" alt="" class="mask_icon">

        <div class="er_img" @click.stop="">
          <img src="@/assets/img/er.jpg" alt="">
          <span>长按识别二维码关注</span>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import { AnalyticEmotion, Hashtable } from "@/assets/js/sinaFaceAndEffec.js";
  import MobileDetect from "@/assets/js/mobile-detect.js";
  import GiftT from "@/components/assembly/GiftT.vue";//引用礼物动画
  import GiftA from "@/components/assembly/GiftA.vue";//引用礼物动画
  import GiftB from "@/components/assembly/GiftB.vue";//引用礼物动画
  import GiftC from "@/components/assembly/GiftC.vue";//引用礼物动画
  import GiftD from "@/components/assembly/GiftD.vue";//引用礼物动画
  import GiftE from "@/components/assembly/GiftE.vue";//引用礼物动画
  import GiftF from "@/components/assembly/GiftF.vue";//引用礼物动画
  import GiftG from "@/components/assembly/GiftG.vue";//引用礼物动画
  import SVGA from "svgaplayerweb"//引用svga
  import AnswerPopup from "@/components/assembly/AnswerPopup.vue"; //问答卷模块
  import SignIn from "@/components/assembly/SignIn.vue"; //签到弹窗
import Hezuo from '@/components/tool/m_hezuo.vue'


  import "@/assets/node_modules/tim-js-sdk/tim-js.js";
  import "@/assets/node_modules/cos-js-sdk-v5/dist/cos-js-sdk-v5.min.js";
  import "@/assets/js/pcmain.js";
  import "@/assets/js/swiper.animate1.0.3.min.js";

  import "@/assets/css/header.css";
  import "@/assets/css/main.css";
  import "@/assets/css/pcsinaFaceAndEffec.css";
  import "@/assets/css/pcmain.css";
  function show_img(t) {
    var t = $(t).find("img");
     
    //页面层
    layer.open({
      type: 1,
      area: ['100%', '70%'], //宽高
      shadeClose: true, //开启遮罩关闭
      end: function (index, layero) {
        return false;
      },
      content: '<div style="text-align:center;z-index: 9999999 !important;">' +
        '<img style="width: 100%;height: 60%" src="' + $(t).attr('src') + '" /></div>'
    });
  }
  var test2, test1, test3, iCount, myPlayer,iCountBubbling;
  export default {
    name: "min_move",
    data() {
      return {
        is_app: this.$store.state.is_app,
        IMG_URL: this.$IMG_URL,
        LIVE_URL: this.$LIVE_URL, //直播前缀
        IM_URL: this.$IM_URL,
        is_loading: false,

        video_border_index: 1, //聊天室切换index
        head_index: 3,
        min_head_index: 1,
        user: {},//用户数据
        chatConter: "", //聊天内容

        chatArr: [], //聊天内容
        page: 1,
        power: 0,//房间类型
        id: "123", //直播房间id
        record_url: "", //视频路径
        recomm_ul: [],//精品留言

        groupid: "", //聊天室组
        sign: "", //userSign签名
        details: {}, //详情
        recommendArr: [], //推荐直播
        maskShow: false, //是否显示遮罩
        goodsNum: 0, //点赞数
        position: 0,
        screenWidth: document.body.clientWidth,
        timer: false,
        photo: "", //上传图片
        maxtime: 0,
        show_tiem: null, //倒计时和视频显示切换
        is_time: false,//是否显示倒计时
        msg: "", //倒计时
        d: -1, //天
        h: -1, //小时
        m: -1, //分
        s: -1, //秒
        type: Number,
        open: Number,
        video: '',
        start_time: '',
        time: '',
        x: '',
        input_value: "",
        roomVideo: true,
        is_ie: false, //是否是ie浏览器
        is_give: false,//是否点赞
        href: '',//公共链接

        is_bottom: false,//是否滑动到底部
        websock: null,
        token: null,//socket token
        sever: null,//socket地址
        startTimeNum: 0,//进入直播间时间挫
        startTimeNumS: 0,//进入页面时间挫

        question: {},//问题答卷
        options_id: null,//正确答案
        is_answerPopup: false,//是否显示答题弹窗
        is_sign: false,//是否显示签到弹窗

        is_gift: true,//是否点击过礼品
        gift_arrT: [],//奖杯礼物动画
        gift_arrA: [],//点赞
        gift_arrB: [],//热气球
        gift_arrC: [],//表情
        gift_arrD: [],//跑车
        gift_arrE: [],//飞机
        gift_arrF: [],//红气球
        gift_arrG: [],//游艇
        gift_user: [],//送礼物用户
        viewers: [],//幸运观众


        is_app: this.$store.state.is_app,

        is_input: false,//是否在输入内容

        user_att:[],
        user_enterArr: [],//用户信息
        color_arr: ['#FFC903', '#FA3131', '#76FF15', '#1FFFCB', '#E539E8'],//用户颜色

        isFun: true,
        is_user_enterArr:true,//是否添加冒泡
      };
    },
    components: {
      AnswerPopup,
      SignIn,
      GiftT, GiftA, GiftB, GiftC, GiftD, GiftE, GiftF, GiftG,Hezuo
    },
    computed: {
      thousandBitSeparator: function () {
        if (!this.goodsNum) return 0;
        let num = this.goodsNum;
        num = num.toString().split(".");  // 分隔小数点
        var arr = num[0].split("").reverse();  // 转换成字符数组并且倒序排列
        var res = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          if (i % 3 === 0 && i !== 0) {
            res.push(",");   // 添加分隔符
          }
          res.push(arr[i]);
        }
        res.reverse(); // 再次倒序成为正确的顺序
        if (num[1]) {  // 如果有小数的话添加小数部分
          res = res.join("").concat("." + num[1]);
        } else {
          res = res.join("");
        }
        return res;
      },
      thousandBitSee: function () {//点赞数
        if (!this.details.see) return 0;
        let num = this.details.see;

        num = num.toString().split(".");  // 分隔小数点
        var arr = num[0].split("").reverse();  // 转换成字符数组并且倒序排列
        var res = [];
        for (var i = 0, len = arr.length; i < len; i++) {
          if (i % 3 === 0 && i !== 0) {
            res.push(",");   // 添加分隔符
          }
          res.push(arr[i]);
        }
        res.reverse(); // 再次倒序成为正确的顺序
        if (num[1]) {  // 如果有小数的话添加小数部分
          res = res.join("").concat("." + num[1]);
        } else {
          res = res.join("");
        }
        return res;
      }
    },

    watch: {
      input_value: function (liem, index) {
         
        if (liem.length > 100) {
          layer.open({
            content: '聊天内容不能大于100个字。',
            time: 1,
            skin: 'msg'
          });
          //  
          this.input_value = liem.substr(0, 100)
        }
      },
      min_head_index: function (liem) {
        if (liem !== 1) {
          $('#emoji_btn_1').hide();
        } else {
          $('#emoji_btn_1').show();
        }
      },
      chatConter: function (liem, index) {
         
        if (liem.length > 100) {
          // layer.open({
          // 	content: '聊天内容不能大于100个字。',
          // 	time: 1,
          // 	skin: 'msg'
          // });
          this.chatConter = index;
        }
      },
      //屏幕宽度改变
      screenWidth(val) {
        // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
        if (!this.timer) {
          // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
          this.screenWidth = val
          this.timer = true
          let that = this
          setTimeout(function () {
            // 打印screenWidth变化的值
            $('#emoji_btn_1').css({
              'left': $('#tupian').offset().left - 40 + 'px'
            })
            $('#emoji_container_1').css({
              'left': $('#tupian').offset().left - 40 + 'px'
            })
            that.timer = false
          }, 400)
        }
      }
    },
    methods: {
      change(evt, hidden) {//浏览器窗口页面切换
        //hidden为false的时候，表示从别的页面切换回当前页面
        //hidden为true的时候，表示从当前页面切换到别的页面
        this.user_enterArr = [];
        if (hidden) {
          this.websock.close();
        }else{
          this.websocketonerror();
        }
      },
      upImgFun() {
        if (!this.is_userFun()) {
          return false;
        }
        if (this.is_app) {
          let that = this;
          let index = layer.open({
            title: [
              '选择方式',
              'background-color: #FF4351; color:#fff;'
            ]
            , content: '<div id="session" style="width: 60%;height: 4rem;border-radius: .6rem;margin: 1rem auto;line-height: 4rem; background: #1AAD19;color:#fff;">拍照</div>' +
              '<div id="circle"  style="width: 60%;height: 4rem;border-radius: .6rem;margin: 1rem auto;line-height: 4rem; background: #1AAD19;color:#fff;">相册</div>'
          });
          $('#session').click(() => {//拍照
            android.pictureMethod(1);
            layer.close(index);
          })
          $('#circle').click(() => {//相册
            android.pictureMethod(2);
            layer.close(index);
          })
        }
      },
      upImg(img) {

        let _this = this;
        _this.websocketsend(JSON.stringify({
          "data": {
            "mine": {
              "name": _this.user.name,
              "image": _this.user.image,
              "id": _this.user.id,
              "mine": true,
              "content": img,
            },
            "to": {
              "id": _this.id,
              "groupname": _this.details.name,
              "avatar": _this.IMG_URL + _this.details.cover,
              "name": _this.details.name,
              'types': 2,
              "type": "group"
            },
            "token": _this.token
          },
          "type": 'chatMessage' //随便定义，用于在服务端区分消息类型
        }))
        var myDate = new Date();
        let getMonth = (myDate.getMonth() + 1) >= 10 ? myDate.getMonth() + 1 : '0' + (myDate.getMonth() + 1);
        let getDate = myDate.getDate() >= 10 ? myDate.getDate() : '0' + myDate.getDate();
        let getHours = myDate.getHours() >= 10 ? myDate.getHours() : '0' + myDate.getHours();
        let getMinutes = myDate.getMinutes() >= 10 ? myDate.getMinutes() : '0' + myDate.getMinutes();
        let time_num = getMonth + '-' + getDate + ' ' + getHours + ':' + getMinutes
        _this.chatArr.unshift({
          id: 0,
          name: _this.user.name,
          image: _this.user.image,
          type: 2,
          center: img,
          time: time_num
        });
        this.backTop();
      },
      wxShareFun(type) {
        let that = this;
        this.wxShare(
          that.detail.title,
          that.detail.cover,
          type
        )
      },

      maskShare() {//app分享
        let that = this;
        let index = layer.open({
          title: [
            '选择分享',
            'background-color: #FF4351; color:#fff;'
          ]
          , content: '<div id="session" style="width: 60%;height: 4rem;border-radius: .6rem;margin: 1rem auto;line-height: 4rem; background: #1AAD19;color:#fff;">分享给好友</div>' +
            '<div id="circle"  style="width: 60%;height: 4rem;border-radius: .6rem;margin: 1rem auto;line-height: 4rem; background: #1AAD19;color:#fff;">分享给朋友圈</div>'
        });
        $('#session').click(() => {//好友
          that.wxShareFun(2);
          layer.close(index);
        })
        $('#circle').click(() => {//朋友圈
          that.wxShareFun(1);
          layer.close(index);
        })
      },
      goBackward() {//返回上一页
        if (window.history.length > 2) {
          this.$router.go(-1);
          window.close();
        } else {
          this.$router.replace('/m_index');
        }
      },
      publicFun() {//公共跳转地址
        if (this.href && this.href !== '') {
          location.href = this.href;
        }
      },
      signFun(type) {//关闭签到
      if (!this.USER() || this.USER().length == 0) {
          layer.open({
            content: "请先登录账号",
            time: true,
            skin: "msg"
          });
          setTimeout(() => {
            this.$router.push('/m_login');
          }, 1000)
          return false;
        }
        this.is_sign = type == 1 ? true : false;
      },
      popupFun() {//答题问答弹窗
        this.is_answerPopup = false;
      },
      answerFun(id) {//答题
        this.options_id = id;
      },
      gift_swiperFun() {//实例礼物swiper
        this.mySwiper = new Swiper('.gift_div', {
          slidesPerView: 4,
        });
      },
      inputBlur() {
        let that = this;
        setTimeout(() => {
          that.is_input = false
        }, 100)
      },
      giftAccording() {//显示礼物
         
        let w = $('.gift_list').height();
        if (w > 0) {
          $('.gift_list').animate({ height: '0' });
        } else {
          $('.gift_list').animate({ height: '10rem' });
        }
      },
      giftAdd(text) {//发送礼物
        if (!this.is_userFun()) {
          return false;
        }
        if (!this.is_gift) {
          layer.open({
            content: "请三秒后再试~",
            time: true,
            skin: "msg"
          });
          return false;
        }
        this.giftAccording();
        this.is_gift = false;
        let that = this;
        setTimeout(() => {
          that.is_gift = true;
        }, 3000)

        this.websocketsend(JSON.stringify({
          data: {
            "mine": {
              "name": this.user.name,
              "image": this.user.image,
              "id": this.user.id,
              "mine": true,
              "content": text,
            },
            "to": {
              "id": this.id,
              "type": "gift"
            },
            "token": this.token
          },
          type: 'gift' //随便定义，用于在服务端区分消息类型
        }))
        let arr = that.gift_user;
        arr.push({
          text: '“' + this.user.name + '”赠送了' + this.giftType(text) + 'x1',
          image: this.user.image,
          type: 1,
        })
        this.$set(that.gift_user, arr)
        this['gift_arr' + text].push(1);
        this.$refs['gift' + text].downGift()
      },
      giftFunT() {//礼物事件
        this.gift_arrT = this.gift_arrT.slice(1);
      },
      giftFunA() {
        this.gift_arrA = this.gift_arrA.slice(1);
      },
      giftFunB() {
        this.gift_arrB = this.gift_arrB.slice(1);
      },
      giftFunC() {
        this.gift_arrC = this.gift_arrC.slice(1);
      },
      giftFunD() {
        this.gift_arrD = this.gift_arrD.slice(1);
      },
      giftFunE() {
        this.gift_arrE = this.gift_arrE.slice(1);
      },
      giftFunF() {
        this.gift_arrF = this.gift_arrF.slice(1);
      },
      giftFunG() {
        this.gift_arrG = this.gift_arrG.slice(1);
      },

      handleAnimation(anim) {
        this.anim = anim
      },
      modelsFun() {//记录机型
        var device_type = navigator.userAgent;//获取userAgent信息
        var md = new MobileDetect(device_type);//实例化mobile-detect
        var os = md.os();//获取系统
        var model = "";
        if (os == "iOS") {//ios系统的处理
          os = md.os() + md.version("iPhone");
          model = md.mobile();
        } else if (os == "AndroidOS") {//Android系统的处理
          os = md.os() + md.version("Android");
        }
        let that = this;
         
        let end_time = new Date().getTime();
        this.$post("census", {
          url: 'min_move?id=' + this.id,
          type: JSON.stringify(md),
          member_id: this.user.id,
          time: end_time - this.startTimeNum,
          times: this.startTimeNumS,
        }).then(eve => {
          that.startTimeNum = end_time;
        })
      },
      giveFun() {//点赞效果
        this.is_give = true;
        let that = this;
        setTimeout(() => {
          that.is_give = false
        }, 100)
      },
      bayFun(e) {//点击回车
        // if (e.which == 13) {
        //   this.out();
        // }
      },
      rollFun() {//聊天记录翻页
        var t = $('#new_message').height();
        var mainContainer = $('#new_message');
        mainContainer.animate({
          scrollTop: $('#new_message').scrollTop() + t
        }, 1000);
      },
      // 解决安卓输入框没有吧页面上推问题
      inputCilick() {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
        if (isAndroid && winh < 900) {

          setTimeout(function () {
            var top = document.activeElement.getBoundingClientRect().top;
            window.scrollTo(0, top);
          }, 500);
        }
        document.querySelector('#inputId').scrollIntoView();
      },
      judgeFun(liem) {//判断登录
        if (liem.power == 0) {
          return true
        }
      if (!this.USER() || this.USER().length == 0) {
          layer.open({
            content: "请先登录账号",
            time: true,
            skin: "msg"
          });
          setTimeout(() => {
            this.$router.push("/m_login");
          }, 1000)
          return false;
        }
        if ((this.USER().plus < 2 && liem.power == 2) || (this.USER().plus == 0 && liem.power == 1)) {
          layer.open({
            content: this.promptPermissions,
            time: true,
            skin: "msg"
          });
          return false
        }
        return true;
      },
      //推荐跳转
      linkPage: function (i) {
        if (!this.judgeFun(i)) {
          return false;
        }
        this.$router.replace({ query: { id: i.id, url: i.live_url, power: i.power } });
        // this.$router.go(0)
        window.location.reload()
      },
      getRecommended: function () {
        //获取推荐
        let that = this;
        this.$get("live_recommend", { type: 0 }).then(eve => {
          that.recommendArr = eve.data;
        });
      },
      joinFun() {//新用户入群
        let that = this;
        $.ajax({
          type: 'post',
          url: this.IM_URL + 'user/joinGroup',
          data: {
            groupid: this.details.chat_id, token: that.token
          },
          success: function (eve) {
            var joinNotify = { type: "joinNotify", "groupid": that.details.chat_id, token: that.token }
            that.websocketsend(JSON.stringify(joinNotify));
          },
        })
      },
      addRegister() {//加入聊天室
        let that = this;
        $.ajax({
          type: 'post',
          url: this.IM_URL + 'register',
          data: {
            chat_id: this.details.chat_id,
            nickname: this.user ? this.user.name : '',
            member_id: this.user ? this.user.id : '',
          },
          success: function (ret) { //成功的回调函数
             
            that.getToken();
          },
          error: function (e) {
             

          }
        });
      },
      getToken() {//获取token
        let that = this;
         
        $.ajax({
          type: 'post',
          url: this.IM_URL + 'login',
          data: {
            chat_id: this.details.chat_id,
            nickname: this.user ? this.user.name : '',
            member_id: this.user ? this.user.id : '',
          },
          success: function (ret) { //成功的回调函数
             
            that.token = ret.data.token;
            that.sever = ret.data.sever;
            that.user = ret.data.user;
            that.initWebSocket();
            if (ret.code == 200) {
              setTimeout(() => {
                that.joinFun();
              }, 500)
            }
          },
          error: function (e) {
             
            that.initWebSocket();
          }
        });
      },
      swiperFun() {
        new Swiper('.videBanner', {
          autoplay: 2000,//可选选项，自动滑动
        });
      },
      is_judge() {//判断房间类型
        let that = this;
      if (!this.USER() || this.USER().length == 0) {
          if (this.power > 0) {
            layer.open({
              content: "请先登录账号",
              time: true,
              skin: "msg"
            });
            setTimeout(() => {
              if (this.GetRequest().code) {
                window.location.href = this.$VIEW_URL;
              } else {
                this.$router.push('/m_login');
              }
            }, 1000)
          } else {
            that.$get('username', {}).then(res => {
               
              that.user = res.data;
              that.funFun();
            })
          }
        } else {
          that.user = this.USER();
          this.funFun();
        }

      },
      funFun() {//执行方法
        let that = this;
        if (!this.isFun) {
          return false;
        }
        this.isFun = false;
        if (this.power > 0) {
        if (!this.USER() || this.USER().length == 0) {
            layer.open({
              content: "请先登录账号",
              time: true,
              skin: "msg"
            });
            setTimeout(() => {
              if (this.GetRequest().code) {
                window.location.href = this.$VIEW_URL;
              } else {
                this.$router.push('/m_login');
              }
            }, 1000)
          }
          if ((this.USER().plus < 2 && this.power == 2) || (this.USER().plus == 0 && this.power == 1)) {
            layer.open({
              content: this.promptPermissions,
              time: true,
              skin: "msg"
            });
            setTimeout(() => {
              this.$router.replace('/m_index');
            }, 1000)
          }
        }
        that.$nextTick(() => {
          that.request();
          that.getmessage();
          that.getRecommended();
        })

        setTimeout(() => {
          that.isFun = true;
          that.gift_swiperFun();
        }, 500)
      },

      request() {
        //获取直播信息
        let that = this;
        this.$post("live_view", { live_id: this.id }).then(eve => {
          that.is_loading = true;
          if (eve.data.mobile_image) {
            eve.data.mobile_image = eve.data.mobile_image.split(',');
          };
          that.details = eve.data;



          that.goodsNum = eve.data.goods;
          that.groupid = eve.data.chatroomId;
          that.video = eve.data.record_url;
          that.record_url = eve.data.live_url;
          that.start_time = eve.data.start_time;
          that.time = eve.data.time;
          that.maxtime = eve.data.date;
          that.open = eve.data.open;
          that.type = eve.data.type;
          that.href = eve.data.href;
          that.power=eve.data.power;
          that.addRegister();
          that.getShare(that.details.name, that.details.cover ? that.details.cover : '');
          document.title = eve.data.name;
          that.initVideo();
          iCountBubbling = setInterval(function () {
            that.bubblingTime();
          }, 1000);
          iCount = setInterval(function () {
            that.timefc();
            if ((that.d == 0 || !that.d) && (that.h == 0 || !that.h) && (that.m == 0 || !that.m) && (that.s == 0 || !that.s)) {
              clearInterval(iCount);
              that.is_time = true;
              setTimeout(() => { that.swiperFun() }, 5000)
              return false;
            }
          }, 1000);
     

        });
      },
      bubbling() {//冒泡请求
        let that = this;
        if (this.user_att.length > 0) {
          if (that.user_enterArr.length < 60) {
            let arr = that.user_enterArr;
            arr.push({
              text: this.user_att[0].text,
              image: this.user_att[0].image.indexOf('logoimg1')>-1 ?  require('../../assets/img/logoimg1.jpg') : this.user_att[0].image,
            })
            this.$set(that.user_enterArr, arr)
          } else {
            that.user_enterArr = [
              {
                text: this.user_att[0].text,
                image: this.user_att[0].image.indexOf('logoimg1')>-1 ?  require('../../assets/img/logoimg1.jpg') : this.user_att[0].image,
              }
            ];
          }
          this.user_att.splice(0,1);
          return false;
        }
        $.ajax({
          type: 'get',
          url: this.IM_URL + 'person',
          data: {},
          success: function (eve) {
            if (eve.data) {
              let data = eve.data;
              that.user_att = data;
            }

          },
        })
      },
      bubblingTime(){
        //获取当前时间
        var date = new Date();
        var now = date.getTime();
        //设置截止时间
        var str = this.maxtime;
        var endDate = new Date(str);
        var end = endDate.getTime();
        //时间差
        var leftTime = end - now;
        //  
        // 直播结束时间

        var jiesuTime = this.start_time + this.time.split('-')[1];
        jiesuTime = jiesuTime.replace(/-/g,"/")
        var end_time = new Date(jiesuTime);
        var endTim = end_time.getTime();
        var rigthTime = now - endTim;
        // 判断直播开始3分钟  结束5分钟请求用户冒泡
        if (leftTime <= 180000 && rigthTime <= 300000) {
          this.bubbling();
        }
      },
      // 倒计时
      timefc: function () {
        //获取当前时间
        var date = new Date();
        var now = date.getTime();
        //设置截止时间
        var str = this.maxtime;
        var endDate = new Date(str);
        var end = endDate.getTime();
        //时间差
        var leftTime = end - now;
       



        //定义变量 d,h,m,s保存倒计时的时间
        var d, h, m, s;
        if (leftTime >= 0) {
          d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
          h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
          m = Math.floor((leftTime / 1000 / 60) % 60);
          s = Math.floor((leftTime / 1000) % 60);
        }
        this.d = d;
        this.h = h;
        this.m = m;
        this.s = s;
        this.is_time = true;
        //type  0直播 1录播   open 0开启1关闭
        if (
          this.type == 0 && leftTime > 0
        ) {
           
          this.msg = "距" +
            '直播开始' +
            "还有" +
            '<span>' + d + '</span>' +
            "天" +
            '<span>' + h + '</span>' +
            "时" +
            '<span>' + m + '</span>' +
            "分" +
            '<span>' + s + '</span>' +
            "秒"
          this.is_time = false;
        } else if (
          this.open == 1 &&
          this.type == 0 &&
          this.d == undefined &&
          this.h == undefined &&
          this.m == undefined &&
          this.s == undefined
        ) {
           
          this.d = 0;
          this.h = 0;
          this.m = 0;
          this.s = 0;
          this.is_time = true;
        } else if (this.open == 0 && this.type == 0) {
           
          // this.d = 0;
          // this.h = 0;
          // this.m = 0;
          // this.s = 0;
          this.is_time = true;
        } else if (this.type == 1) {
           
          this.d = 0;
          this.h = 0;
          this.m = 0;
          this.s = 0;
        }
      },
      is_userFun() {
        // if (!this.USER() || this.USER() == {}) {
        if (this.details.is_message == 0 && (this.user.mobile == '' || !this.user.mobile)) {
          layer.open({
            content: "请先登录账号",
            time: true,
            skin: "msg"
          });
          this.websock.close();
          setTimeout(() => {
            this.$router.push("/m_password");
          }, 1000);
          return false;
        }
        return true;
      },
      out: function () {
        //发送
        var inputText = $(".text").val();
        if (!inputText) {
          layer.open({
            content: "请输入内容",
            time: true,
            skin: "msg"
          });
          return false;
        }
        let that = this;
        this.$post("forbidden", { member_id: this.user.id, chat_id: this.details.chat_id }).then(e => {
          if (e.data == 1) {
            layer.open({
              content: "你已被禁言",
              time: true,
              skin: "msg"
            });
          } else if(e.data == 3) {
            layer.open({
              content: "当前直播未开启留言功能",
              time: true,
              skin: "msg"
            });
          } else {
            $('#info-show ul').append(that.send(AnalyticEmotion(inputText)))
          }
        })
      },
      send: function (content) {
        //发送消息
        if (!this.is_userFun()) {
          return false;
        }
        this.websocketsend(JSON.stringify({
          data: {
            "mine": {
              "name": this.user.name,
              "image": this.user.image,
              "id": this.user.id,
              "mine": true,
              "content": content
            },
            "to": {
              "id": this.id,
              "groupname": this.details.name,
              "avatar": this.IMG_URL + this.details.cover,
              "name": this.details.name,
              'types': 1,
              "type": "group"
            },
            "token": this.token
          },
          type: 'chatMessage' //随便定义，用于在服务端区分消息类型
        }))

        var myDate = new Date();
        let getMonth = (myDate.getMonth() + 1) >= 10 ? myDate.getMonth() + 1 : '0' + (myDate.getMonth() + 1);
        let getDate = myDate.getDate() >= 10 ? myDate.getDate() : '0' + myDate.getDate();
        let getHours = myDate.getHours() >= 10 ? myDate.getHours() : '0' + myDate.getHours();
        let getMinutes = myDate.getMinutes() >= 10 ? myDate.getMinutes() : '0' + myDate.getMinutes();
        let time_num = getMonth + '-' + getDate + ' ' + getHours + ':' + getMinutes
        this.chatArr.unshift({
          id: 0,
          name: this.user.name,
          image: this.user.image,
          type: 1,
          center: content,
          time: time_num
        });
        this.input_value = "";
        $(".text").val('');
        this.backTop();
      },
      // 页面回到顶部
      backTop: function () {
        document.getElementById('new_message').scrollTop = 0;
        let that = this;
        let timer = setInterval(function () {
          let ispeed = Math.floor(-that.scrollTop / 5);
          document.documentElement.scrollTop = document.body.scrollTop =
            that.scrollTop + ispeed;
          if (document.documentElement.scrollTop === 0) {
            clearInterval(timer);
          }
        }, 16);
      },

      //上传图片
      handleChange: function (e) {
        if (!this.is_userFun()) {
          return false;
        }
        let _this = this;
        let images = "";
        var reader = new FormData();
        reader.append("file", e.target.files[0]);
        //发送图片消息
        $.ajax({
          type: "POST", //提交方式
          url: this.$URL + 'upload', //路径
          data: reader,
          processData: false,
          contentType: false,
          success: function (result) { //返回数据根据结果进行相应的处理
            _this.upImg(result.data)
          }
        });
      },
      //获取历史聊天记录
      getmessage: function () {
        let that = this;
        this.$post("message", {
          live_id: this.id,
          page: that.page,
          limit: 10
        }).then(eve => {
          that.chatArr = that.chatArr.concat(eve.data);
          that.$nextTick(() => {
            that.addImg();
          })
        });
      },
      //监听聊天页面滚动
      handleScroll: function (e) {
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        var scrollTop = e.target.scrollTop;
        //变量windowHeight是可视区的高度
        var windowHeight = e.target.clientHeight;
        //变量scrollHeight是滚动条的总高度
        var scrollHeight = e.target.scrollHeight;
        if (scrollTop + windowHeight >= scrollHeight - 60) {
          this.is_bottom = true;
        } else {
          this.is_bottom = false;
        }
        //滚动条到底部的条件
        if (scrollTop + windowHeight >= scrollHeight - 20) {
          this.page++;
          this.getmessage();
        }
      },
      goods: function () {
        //点赞
        let that = this;
        this.SVGA();



        this.$get("goods", {
          live_id: this.id
        }).then(eve => {
          that.goodsNum = eve.data;
        });
      },
      //关注- 遮罩
      maskShowc: function () {
        this.maskShow = !this.maskShow;
         
      },
      _isMobile() {
        let flag = navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        );
        return flag;
      },
      refresh(type) {//刷新数量
        let that = this;
        this.$post("num", { live_id: this.id }).then(e => {
          that.goodsNum = e.data.data ? e.data.data : that.goodsNum;
          that.details.see = e.data.see ? e.data.see : that.details.see;
          var myPlayerT = this.$video("myVideo");
          that.show_tiem = e.data.open;
          if (e.data.open !== 1) {
            if (type == 1) {
              myPlayerT.play();
            }
          } else {
            myPlayerT.pause();
          }
          that.details.live_date = e.data.date ? e.data.date : that.details.live_date;
        })

        this.$post("mess_recomm", { live_id: this.id, page: 1, limit: 999999 }).then(e => {
          that.recomm_ul = e.data;
        })
      },
      initVideo() {
        //初始化视频方法
        myPlayer = this.$video(myVideo, {
          //确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
          controls: true,
          //自动播放属性,muted:静音播放
          autoplay: "muted",
          //建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
          preload: "auto",
          'x5-video-player-type': "h5",
          'x5-playsinline': 'true',
          'playsinline': 'true',
          "webkit-playsinline": 'true',
        });
        myPlayer.src(this.record_url);
        myPlayer.load(this.record_url);
      },
      getChat() {
        let that = this;
        this.$post("message", { live_id: this.id, page: 1, limit: this.page * 10 }).then(e => {
          that.chatArr = e.data;
        })
      },
      addImg() {
        $('.li_r_img img').on("click", function () {
          $(this).ImgZoomIn('');
        });
      },
      luckyFun() {//幸运观众
        var swiper = new Swiper('.lucky_swiper', {
          direction: 'vertical',
          loop: true,
          autoplay: 2000,
        });
      },
      initWebSocket() { //初始化weosocket
        const wsuri = this.sever;
        this.websock = new WebSocket(wsuri + '?token=' + this.token);
        this.websock.onmessage = this.websocketonmessage;
        this.websock.onopen = this.websocketonopen;
        this.websock.onerror = this.websocketonerror;
        this.websock.onclose = this.websocketclose;
      },
      websocketonopen() { //连接建立之后执行send方法发送数据
        // let actions = {"test":"12345"};
        // this.websocketsend(JSON.stringify(actions));
        let that = this;
        test1 = setInterval(function () {
          that.websocketsend(JSON.stringify({ "type": "ping" }));
        }, 1000 * 10)
         
      },
      websocketonerror() {//连接建立失败重连
        this.initWebSocket();
         
      },
      websocketonmessage(e) { //数据接收
        const redata = JSON.parse(e.data);
         
         

        let that = this;

        // if (redata.type == 'joinNotify') {
        //   if(!this.is_user_enterArr){
        //       return false;
        //   }
        //   that.is_user_enterArr = false;
        //   setTimeout(()=>{
        //     that.is_user_enterArr = true;
        //   },500)
        //   let data = redata.data;//{"system":true,"id":80,"type":"group","content":"湖南省用户15927276570加入了群聊，欢迎下新人吧～"}
        //   if (that.user_enterArr.length < 30) {
        //     let arr = that.user_enterArr;
        //     arr.push({
        //       text: data.content,
        //       image: data.image,
        //     })
        //     this.$set(that.user_enterArr, arr)
        //   } else {
        //     that.user_enterArr = [];
        //   }
        // }
        // 幸运观众
        if (redata.type == 'luck') {
          this.viewers.push(redata.data);
          this.luckyFun();
        }
        //送礼品
        if (redata.type == 'gift') {
          let data = redata.data;
          this['gift_arr' + data.content].push(1);
          this.$refs['gift' + data.content].downGift();
          if (that.gift_user.length < 30) {
            let arr = that.gift_user;
            arr.push({
              text: '“' + data.name + '”赠送了' + this.giftType(data.content) + 'x1',
              image: data.image,
              type: 1,
            })
            this.$set(that.gift_user, arr)
          } else {
            that.gift_user = [];
          }
        }
        // 问答卷
        if (redata.type == 'question') {
          this.question = redata.data;
          this.question.userId = this.user.id;
          if (this.question.type !== 2) {
            this.options_id = null;
          }
          this.is_answerPopup = true;
        }

        if (redata.live_id == this.id) {
          this.chatArr = [{
            member_id: redata.fromid,
            center: redata.content,
            time: redata.timestamp,
            name: redata.name,
            type: redata.types,
            image: redata.image,
            id: redata.fromid == this.user.id ? 0 : 1,
          }].concat(this.chatArr);
        }
        that.$nextTick(() => {
          that.addImg();
        })
      },
      websocketsend(Data) {//数据发送
         
        this.websock.send(Data);
        let that = this;
        that.$nextTick(() => {
          that.addImg();
        })
      },
      websocketclose(e) {  //关闭
         
      },
      SVGA() {
        let player = new SVGA.Player("#demoCanvas");
        let parser = new SVGA.Parser("#demoCanvas");
        parser.load('http://www.anesthesiavision.cn/svga/icon1.svga', function (videoItem) {
          //this.bgImg，图片路径需要线上地址，本地引用会报错
          // player.loops  = 1;//循环时间
          player.clearsAfterStop = true;//循环完成后是否清除
          player.setVideoItem(videoItem);//实例svga动画
          player.startAnimation();//开始哦播放
          player.onFrame(function (i) {//监听针数
            // player.pauseAnimation();
            //  
          });
        }
        );
      },
      setFill() {               //适配不同屏
        var $_canvas = document.getElementById("demoCanvas"),
          // w = window.innerWidth,
          // h = window.innerHeight,
          w = $('#demoCanvas').width(),
          h = $('#demoCanvas').height(),
          screen_proportion = h / w,
          svga_proportion = 16 / 9;
        if (screen_proportion > svga_proportion) {
          //长屏幕
          // $_canvas.style.width = h / svga_proportion + "px";
          // $_canvas.style.left = (w - h / svga_proportion) / 2 + "px";
        } else {
          // $_canvas.style.height = w * svga_proportion + "px";
          // $_canvas.style.top = (h - w * svga_proportion) / 2 + "px";
        }
      }
    },

    created() {
      this.startTimeNum = new Date().getTime();//获取进入直播时间
      this.startTimeNumS = new Date().getTime();//获取进入直播时间  
    },
    mounted() {
      // this.setFill();
      // this.SVGA();
      window.upImg = this.upImg;

      let that = this;
      that.id = that.$route.query.id;
      that.record_url = that.$route.query.url;
      this.power = this.$route.query.power;
      this.is_judge();

      $(".face-icon").SinaEmotion($(".text"));
      $('.face-icon').click(function () {
        $('#emotions').css({ 'left': 0, 'width': '100%' })
      })
      document.onkeydown = function (event) {
        var e = event || window.event || arguments.callee.caller.arguments[0];
        if (e && e.keyCode == 13) { // enter 键
          //要做的事情
          that.out()
          // alert("按 Enter");
        }
      };

      window.addEventListener("scroll", this.handleScroll, true);
      this.refresh(1);
      this.addImg();
      that.modelsFun()
      test2 = setInterval(function () {
        that.refresh(0);
        that.modelsFun();
      }, 10000)
      test3 = setInterval(function () {
        that.getChat();
        that.addImg();
      }, 20000)
      if (this._isMobile()) {
        // alert("手机端");
        // this.$router.replace({path: 'min_move',query:{ id:this.id,url:this.record_url}});
      } else {
        // alert("pc端");
        this.$router.replace({ path: 'pc_move', query: { id: this.id, url: this.record_url } });
      }
      //百度统计
      var _hmt = _hmt || [];
      (function () {
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?8379155748b2097b694a2dcc7678ee2e";
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
      })();
      // 进入房间欢迎语动画
      setTimeout(() => {
        $('.welcome').animate({ top: '20px', opacity: '1' }, 1000, function () {
          let data = $(this);
          setTimeout(function () {
            data.animate({ opacity: '0' }, 1000)
          }, 1000)
        })
      }, 1000)
    },
    destroyed() {
      // this.modelsFun();
      this.websock.close() //离开路由之后断开websocket连接
      myPlayerT.pause();
      clearInterval(test2)
      clearInterval(test1)
      clearInterval(test3)
      clearInterval(iCount)
      clearInterval(iCountBubbling)

    },
    beforeDestroy: function () {
      this.websock.close() //离开路由之后断开websocket连接
      myPlayerT.pause();
      clearInterval(test2)
      clearInterval(test1)
      clearInterval(test3)
      clearInterval(iCount)
      clearInterval(iCountBubbling)

    },
  };
</script>
<style>
  #emotions {
    width: 100%;
    z-index: 999;
  }

  .min_text_center.tool_div img {
    width: 100%;
  }

  .mess_recomm_li_cetnter img {
    width: auto !important;
  }

  .mess_recomm_li_cetnter.mess_recomm_img img {
    width: 100% !important;
  }

  .vjs-modal-dialog-content,
  .video-js .vjs-modal-dialog {
    display: none !important;
  }

  #msgT.count span {
    color: #ff0000 !important;
  }
</style>
<style scoped>
  #emotions {
    left: 0 !important;
  }

  html,
  body {
    max-width: 100vw;
    height: 100vh;
    text-align: left;
  }

  .visible-xs {
    width: 100vw;
    overflow: hidden;
    /* padding-top: 0rem; */
  }

  .m_header {
    background: transparent;
    box-shadow: 0 0 0 transparent;
  }
    /* .m_header i{
      background-color: #ffffff;
      border-radius: 50%;
    } */


  .topBox {
    height: 4.5rem;
    background: #fff;
    padding: 0 1.5rem;
  }

  .isshow {
    display: none;
  }

  .topBox img {
    width: 12.7rem;
  }

  .topBox .goWebsite {
    background-color: #db414e;
    height: 2rem;
    padding: 0 1rem;
    font-size: 1.2rem;
    color: #fff;
    border-radius: 0.5rem;
    cursor: pointer;
    line-height: 1em;
  }

  .banner_swiper1 {
    height: 225px;
    width: 100%;
    position: relative;
  }

  .banner_swiper1 .swiper_item {
    background-size: cover !important;
    background-repeat: no-repeat !important;
    background-position: center !important;
  }

  .banner .swiper-pagination1 {
    position: absolute;
    bottom: 1rem;
    left: 50%;
    transform: translateX(-50%);
    z-index: 999;
  }

  .banner .swiper-pagination1 .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    background: rgba(0, 0, 0, 1);
    transition: all 0.5s ease;
    margin: 0 0.2rem;
  }

  .banner .swiper-pagination1 .swiper-pagination-bullet.swiper-pagination-bullet-active {
    width: 30px;
    height: 12px;
    border-radius: 6px;
    background: #fff;
  }

  .selectBox {
    padding: 1.5rem 1.6rem;
    width: 100%;
  }

  .selectBox div {
    display: inline-block;
    width: calc(50% - 0.7rem);
    height: 4rem;
    text-align: center;
    line-height: 4rem;
    cursor: pointer;
    border-radius: 3px;
    background-color: #f4f4f4;
    color: #000;
    font-size: 1.5rem;
    font-weight: bold;
  }

  .content {
    padding: 0 2rem;
  }

  .content .panel-default>.panel-heading {
    background-color: #ccc;
  }

  .selectBox .bule {
    background-color: #db414e;
    color: #fff;
    position: relative;
  }
.claloadding {
  width: 100%;
  height: 50vh;
  margin: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: transparent;
}
  .selectBox .bule::after {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 100%);
    content: "";
    width: 0;
    height: 0;
    border-width: 0.8rem;
    border-style: solid;
    border-color: #db414e transparent transparent transparent;
  }

  .video_content {
    padding: 1rem 0;
  }

  .video_ul {
    padding: 0 1.5rem;
  }

  .video_ul .video_li {
    margin-bottom: 1rem;
    background: #fff;
    box-shadow: 0.35rem 0 2.3rem rgba(71, 71, 71, 0.17);
    border-radius: 0.5rem;
    padding: 0 2.1rem;
    min-height: 16.05rem;
  }

  .video_ul .video_li .video_li_title {
    width: 100%;
    align-items: center;
  }

  .video_ul .video_li .video_li_title .title {
    max-width: calc(100% - 4rem);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 1.8rem;
    font-weight: bold;
  }

  .video_ul .video_li .video_li_title .tag {
    margin-left: 0.9rem;
    width: 3rem;
    height: 1.55rem;
    border-radius: 0.2rem;
    background: #ee8a60;
    color: #ffffff;
    font-size: 1rem;
    line-height: 1em;
  }

  .video_ul .video_li .video_head {
    padding: 1.8rem 0;
    height: 8.9rem;
    flex-direction: column;
    align-items: flex-start;
    border-bottom: 0.05rem dashed #e4e4e4;
  }

  .video_ul .video_li .video_head .video_time>.video_time_img {
    width: 1.7rem;
    margin-right: 0.55rem;
  }

  .video_ul .video_li .video_head .video_time>span {
    font-size: 1.12rem;
    color: #818a92;
  }

  .video_center {
    align-items: center;
    min-height: calc(100% - 9rem);
    padding-bottom: 1.05rem;
  }

  .video_center>.touxiao {
    width: 3.5rem;
    height: 3.5rem;
    border-radius: 50%;
    margin-right: 0.8rem;
  }

  .video_center .video_name {
    font-size: 1.2rem;
    color: #525963;
  }

  .video_center .tag_title {
    margin-left: 1.8rem;
  }

  .video_center .tag_title>span {
    font-size: 1.2rem;
    color: #525963;
    margin-right: 10px;
    white-space: nowrap;
  }

  .Live {
    display: flex;
    flex-direction: column;
  }

  .Live li {
    text-align: center;
    padding: 2rem 10px;
    border-radius: 5px;
    margin: 1rem;
    display: flex;
    background-color: rgba(242, 242, 242, 1);
    align-content: center;
    justify-content: center;
  }

  .Live li .bigTitle {
    font-size: 1.5rem;
    font-weight: 600;
    display: block;
    line-height: 1.7rem;
    margin-bottom: 5px;
  }

  .Live li .title {
    width: 26rem;
    display: inline-block;
    text-align: left;
  }

  .Live li .info {
    color: #aeaeae;
  }

  .Live li .playTime {
    width: 10rem;
    display: flex;
    align-content: center;
    justify-content: center;
    flex-direction: column;
  }

  .Live li .play {
    font-size: 2rem;
    display: block;
  }

  .playBox {
    position: fixed;
    width: 100%;
    height: 100%;
    background-color: rgba(242, 242, 242, 0.5);
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    visibility: hidden;
  }

  .Box {
    width: 100%;
    background-color: #ccc;
    position: relative;
    display: flex;
    align-items: center;
  }

  .Box .closePlay {
    float: right;
    margin: 10px;
    color: #fff;
    cursor: pointer;
    position: absolute;
    z-index: 2;
    right: 0;
    top: 0;
  }

  .foot {
    text-align: center;
    height: 6rem;
    border-top: 0.1rem solid rgba(247, 244, 248, 0.8);
  }

  .foot a {
    color: #000;
  }

  .layui-m-layershade {
    background-color: rgba(0, 0, 0, 0.1);
    pointer-events: auto;
    z-index: 999999 !important;
  }

  .mask {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0, 0, 0, 0.7);
    z-index: 9999999;
  }

  .video-js .vjs-tech {
    /* position: fixed;
            top: -19%;
            left: 0;
            width: 100%;
            height: 100%; */
  }

  .showtime {
    background-color: #ffffff;
    padding: 0.1rem 0.8rem;
    text-align: left;
  }

  body {
    height: 100vh;
  }

  .center {
    /* height:100vh; */
  }

  .min_img>img {
    width: 100%;
    display: block;
    margin: 0 auto;
    /* height: 9.0rem; */
    /* margin-top: 0.01rem; */
  }

  .mask .mask_icon {
    width: 3rem;
    height: 3rem;
    position: absolute;
    right: 3rem;
    top: 5rem;
  }

  .mask .er_img {
    display: block;
    width: 18rem;

    top: 50%;
    z-index: 9999;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .mask .er_img>img {
    width: 100%;
  }

  .mask .er_img>span {
    display: block;
    margin-top: .4rem;
    color: #fff;
    font-size: 1.8rem;
    white-space: nowrap;
    text-align: center;
  }

  .pc_center {
    display: none;
  }

  .topBox .goWebsite {
    background-color: #db414e;
    height: 2rem;
    width: auto;
    padding: 0 1rem;
    display: flex;
    font-size: 1.2rem;
    color: #fff;
    border-radius: 0.5rem;
    cursor: pointer;
    line-height: 1em;
  }

  .isshow {
    display: none;
  }

  #index {
    /* padding-bottom: 4.7rem; */

    width: 100%;
    height: 100%;
    min-height: 100vh;
  }

  .min_center {
    display: block;
    /* padding: 0 0.4rem; */
    height: 100%;
  }

  .foot {
    height: 4rem;
    border-top: 0.1rem solid #eee;
    display: none;
  }

  .main {
    max-width: none;
    min-width: none;
    margin: 0 auto;
    width: 100%;
  }

  header {
    height: 4.5rem;
  }

  header .topBox {
    height: 100%;
    padding: 0 1.5rem;
  }

  header .logo {
    width: 12.7rem !important;
  }

  header .portrait_div>i.portrait {
    width: 2.6rem !important;
    height: 2.6rem !important;
  }

  header .portrait_div>.name {
    font-size: 1.2rem !important;
  }

  /* 直播区域 */
  .min_live_div {
    /* padding-top: 4.5rem; */
    height: calc(100vw / 1.78);
    background: #000;
    font-size: 0;
  }

  .video_left_top .video_title {
    width: calc(100% - 6rem);
  }

  .video_left_top .video_title>i {
    width: 3rem;
    height: 3rem;
    background: #f1f1f1;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 0.8rem;
  }

  .video_left_top .video_title .title_name {
    flex-direction: column;
    color: #1a1a1a;
    font-weight: bold;
  }

  .focus {
    white-space: nowrap;
    font-size: 1.2rem;
    width: 6.5rem;
    height: 100%;
    background: #f24d5b;
    color: #fff;
    position: absolute;
    right: 0;
    top: 0;
  }

  .focus>img {
    width: 1.2rem;
    height: 1.2rem;
    margin-right: 0.4rem;
  }

  .min_live_div {
    width: 100%;
    font-size: 0;
    /* background: #f7f7f7; */
    position: relative;
    /* z-index: -9; */
    background-color: #000000;
  }

  .min_live_div>video {
    width: 100%;
    height: 100%;
  }

  .min_live_div .video-js {
    width: 100%;
    height: 100%;
  }

  .min_live_div .count {
    /* position: absolute;
			margin: 0;
			left: 0;
			bottom: 0; */
    width: 100%;
    height: 100%;
    line-height: 22.5rem;
    color: red;
    font-weight: bold;
    background-color: rgba(0, 0, 0, 0);
    text-align: center;
    z-index: 99 !important;
  }

  .video-js {
    /* display: none; */
  }

  .min_text_head {
    height: 4.2rem;
    padding: 0 1.5rem;
    border-bottom: 0.05rem solid #cccccc;
    align-items: center;
    background-color: #ffffff;
    position: relative;
  }

  .min_text_head .min_head_tag {
    height: 100%;
    font-size: 1.4rem;
    color: #777;
    margin-right: 2.4rem;
  }

  .min_text_head .min_head_tag.selected {
    color: #1a1a1a;
    font-weight: bold;
    position: relative;
  }

  .min_text_head .min_head_tag.selected::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 50%;
    height: 0.2rem;
    width: 100%;
    border-radius: 0.1rem;
    transform: translateX(-50%);
    background: #f24c5a;
  }

  /* min聊天 */
  .min_text_div {
    /* height: 54vh; */
    height: calc(100vh - (10rem + calc(100vw / 1.77)));

    /* overflow-x: hidden; */
    overflow: hidden;
    position: relative;
  }

  .containers_box {
    height: auto;
    overflow-y: auto;
    height: calc(100vh - 30rem);
    background-color: #ffffff;
  }

  .min_chat_ul {
    padding: 0.5rem 1.5rem 5rem 1.5rem;
    height: calc(100% - 6rem);
    overflow-y: auto;
    background-color: #ffffff;
  }

  .min_chat_ul .min_chat_li {
    padding: 1.3rem 0;
  }

  .min_chat_li .right .chat_li_center {
    text-align: right;
  }

  .min_chat_li .chat_li_top {
    align-items: center;
  }

  .min_chat_li .chat_li_top>i {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 50%;
    overflow: hidden;
    background: #f1f1f1;
    margin-right: 0.5rem;
  }

  .min_chat_li .chat_li_top .chat_head_name {
    font-size: 1.12rem;
    color: #3285d9;
  }

  .min_chat_li .chat_li_top .chat_head_time {
    font-size: 1.12rem;
    margin-left: 1.1rem;
    color: #999999;
  }

  .min_chat_li .chat_li_center {
    margin-top: 0.8rem;
    font-size: 1.4rem;
    color: #1a1a1a;
    text-align: left;
    white-space: normal;
    word-break: break-all;
    word-wrap: break-word;
  }

  .discuss_li.red .chat_head_name,
  .discuss_li.red .chat_li_center {
    color: #ff0000 !important;
    font-weight: bold;
  }


  /* min推荐 */
  .min_text_center.recommended_ul {
    padding: 0 1.5rem;
    height: auto;
    overflow-y: auto;
  }

  .min_text_center .recommended_li {
    height: 8rem;
    padding: 1rem 0;
    cursor: pointer;
    border-bottom: 1px solid #dfdfdf;
    -moz-user-select: none;
    -khtml-user-select: none;
    user-select: none
  }

  .min_text_center .recommended_li_img {
    width: 11rem;
    height: 6.2rem;
    border-radius: 0.2rem;
    margin-right: 1rem;
    overflow: hidden;
    background: #f1f1f1;
  }

  .min_text_center .recommended_li_img>img {
    width: 100%;
  }

  .min_text_center .recommended_text {
    width: 100%;
    height: 100%;
    flex: 1;
    flex-direction: column;
    align-items: flex-start;
  }

  .min_text_center .li_title {
    font-size: 1.5rem;

    line-height: 1.4em;
    text-align: left;
    font-weight: bold;
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    color: #1a1a1a;
  }

  .min_text_center .recommended_text .li_time {
    font-size: 1.2rem;
    color: #666;
  }

  .min_text_center .recommended_text .li_time>i {
    width: 1.2rem;
    margin-right: 0.35rem;
  }

  /* 富文本框 */
  .min_text_center.tool_div {
    padding: 0 1.5rem;
    height: auto;
    overflow-y: auto;
  }

  .tool_div img {
    width: 100%;
  }

  /* 聊天输入框 */
  .chat_input {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 99;
    min-height: 4rem;
    padding: 0.8rem 1.5rem;
    background: #fff;
    box-shadow: 0.3rem 0 2.3rem rgba(71, 71, 71, 0.17);
    padding-right: 1rem;
  }

  .chat_input>i {
    width: 2rem;
  }

  .chat_input i.give {

    width: 2.5rem !important;
    height: 2.5rem !important;
    border-radius: 50% !important;
    padding: 0 !important;
    /* overflow: hidden !important; */
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    box-shadow: none !important;
    position: relative !important;
    margin-right: .4rem;
    background: #f24d5b;
  }

  .chat_input>i.give>i {
    width: 2rem;
    height: 2rem;
  }

  .chat_input i.give.giveLike {
    background: #ccc;
    color: rgba(255, 74, 89, 1);
  }

  .chat_input i.give img {
    width: 1.2rem;
    box-shadow: none !important;
    background: none !important;
  }

  .chat_input .input_div {
    width: calc(100% - 9rem);
    background: rgba(244, 246, 249, 1);
    border-radius: 0.4rem;
    border: 0.1rem solid rgba(226, 226, 226, 1);
    padding: 0 0 0 1.3rem;
    min-height: 3.5rem;
  }

  .chat_input .input_div>.input {
    width: calc(100% - 4rem);
    border: 0;
    background: transparent;
    outline: transparent;
    font-size: 1.3rem;
    color: #999999;
    line-height: 1.6em;
    height: 100%;
  }

  .chat_input .input_div>span {
    color: #ffffff;
    font-size: 1.2rem;
    padding: 0.8rem 0.6rem;
    background-color: red;
    border-radius: 0 0.4rem 0.4rem 0;
  }

  #camvasId {
    /* position: fixed;
            bottom: 0;
            right: 0; */
  }

  .emoji_btn {
    position: fixed;
    top: calc(100vh - 4rem) !important;
    left: 1rem !important;
    z-index: 999;
  }

  #emoji_container_1 {
    position: fixed;
    top: calc(100vh - 330px) !important;
    left: 50% !important;
    width: 100vw;
    transform: translateX(-50%);
  }

  #btn {
    margin: 0;
  }

  input {
    height: 100%;
    width: 85%;
    box-sizing: border-box;
  }

  .give_box {
    display: flex;
    justify-content: center;
    align-content: center;
    font-size: 0;
    min-width: 4rem;
    margin-left: .6rem;

  }

  .give_box>span {
    line-height: 35px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    line-height: 1.1em;
    overflow: hidden;
    font-size: 1rem;
  }

  #roomVideo_html5_api {
    width: 100%;
    height: 100%;
  }

  .layui-m-layer1 .layui-m-layerchild {
    background-color: transparent;
  }

  .tools-box .submit-btn input {
    font-size: 1.4rem;
  }

  .title_h5 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    text-align: left;
    overflow: hidden;
  }

  #roomVideo {
    object-fit: cover;
    object-position: center center;
  }

  #seeNum i {
    margin-right: 0.6rem;
  }

  #seeNum {
    position: absolute;
    top: 1.2rem;
    padding: 0.1rem 1rem;
    border-radius: 10px;
    background: rgba(122, 148, 154, 0.4);
    right: 1rem;
    color: #fff;
    font-size: 1.2rem;
    z-index: 9999;
  }

  #seeNum i img {
    width: 1.6rem;

  }

  #emotions {
    left: 0 !important;
    width: 100vw;
    bottom: 5.2rem !important;
  }


  /* 直播banner */
  .video_banner {
    height: 4.4rem;
    background-color: #B5A3AA;
    overflow: hidden;
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
  }

  .video_banner h4 {
    font-size: 1.4rem;
    color: #fff;
  }

  /* 更多消息 */
  .more_news {
    position: fixed;
    bottom: 6rem;
    left: 50%;
    transform: translatex(-50%);
    background: #f24d5b;
    border-radius: 2.4rem;
    width: 10.5rem;
    height: 3rem;
    color: #fff;
    font-size: 1.1rem;
    z-index: 9999;

  }

  .more_news>img {
    width: 1.05rem;
    margin-right: .5rem;
  }

  .roomVideo_bg {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-repeat: no-repeat;
    background-color: #000;
    background-size: cover;
    background-position: center;
  }

  .text_content {
    flex: 1;
  }

  .video_bottom_banner {
    background-repeat: no-repeat;
    background-size: 100% auto;
    background-position: center;
  }

  .submit {
    flex: 1;
    margin: 0 .5rem;
  }

  #ImgZoomInImage {
    width: 80vw !important;
  }

  .inp_img_box {
    position: relative;
    margin-right: .04rem;
    overflow: hidden;
  }

  .inp_img_box .inp_img {
    position: absolute;
    top: 0;
    opacity: 0;
    /* border:.05rem solid #ff0000; */
    left: 0;
    right: 0;
    bottom: 0;
    width: 1.6rem;
  }

  .welcome {
    position: fixed;
    text-align: center;
    top: -.5rem;
    left: 50%;
    opacity: 0;
    transform: translateX(-50%);
    max-width: 80vw;
    min-width: 30vw;
    min-height: .25rem;
    padding: .5rem 1.6rem;
    font-size: 1.2rem;
    color: #333;
    box-shadow: .1rem .1rem 1.2rem rgba(247, 244, 248, 0.8);
    border-radius: .5rem;
    background: #fff;
    z-index: 9999;

  }

  .face-icon img {
    width: 2.2rem;
    transform: translateY(-5%);
  }


  .video_banner .swiper-container {
    height: 100%;
    width: 100%;
  }

  .video_banner .swiper-container .swiper-slide {
    width: 100vw;
  }

  .video_banner .swiper-container .swiper-slide img {
    width: 100%;
  }



  .user_enter {
    position: absolute;
    bottom: 6rem;
    right: 1rem;
    pointer-events: none;
  }

  .user_enter .user_enter_li {
    font-size: 1.6rem;
    color: #333;
    position: absolute;
    bottom: 0;
    opacity: 0;
    right: 0;
    white-space: nowrap;
    animation: myfirst 4s ease;
  }

  .user_enter .user_enter_li .user_enter_portrait {
    width: 3rem;
    height: 3rem;
    border-radius: 50%;
    overflow: hidden;
    display: block;
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    margin-right: 1rem;
  }

  @keyframes myfirst {
    0% {
      bottom: 0;
      opacity: 0;
    }

    20% {
      bottom: 4rem;
      opacity: 1;
    }

    100% {
      bottom: 16rem;
      opacity: 0;
    }
  }

  .announcement_bg {
    position: relative;
  }

  .announcement_bg .msgText {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    left: 50%;
    color: #000;
    white-space: nowrap;
  }


  .discuss_title {
    font-size: 2.2rem;
    color: #1a1a1a;
    font-weight: bold;
    margin-bottom: 1rem;
    padding-top: 1rem;
  }

  .discuss_title.heng {
    border-top: .005rem solid #e2e2e2;
    padding-top: 1.8rem;
  }

  .discuss_center {
    margin-bottom: 1.6rem;
  }

  .discuss_center .mess_recomm_li {
    margin: 1.6rem 0;
  }

  .discuss_center .mess_recomm_li>h6 {
    font-size: 1.4rem;
    color: #3285d9
  }

  .discuss_center .mess_recomm_li>h6>i {
    width: 3rem;
    border-radius: 50%;
    overflow: hidden;
    height: 3rem;
    margin-right: .6rem;
  }

  .discuss_center .mess_recomm_li>.mess_recomm_li_cetnter {
    font-size: 1.4rem;
    margin-top: .6rem;
    word-wrap: break-word;
  }

  .mess_recomm_li_cetnter.mess_recomm_img img {
    width: 100%;
  }


  #demoCanvas {
    width: 200px;
    height: 200px;
    position: absolute;
    bottom: 6rem;
    right: 0;
  }

  .tools-box img {
    width: 100%;
  }


  .submit .face-icon {
    width: 2.45rem;
    margin: 0;
  }

  .inp_img_box {
    width: 1.6rem;
    height: 100%;
  }

  .gift_icon.inp_img_box {
    width: 2.75rem;
    align-items: center;
    font-size: 0;
    display: inline-flex;
    justify-content: center;
  }

  .submit {
    width: auto;
    flex: 1;
    padding: 0 .9rem;
    height: 3.3rem;
    background: #EEEEEE;
    border-radius: .5rem;
    margin: 0 1rem;
    border: 0;
  }

  .chat_input i.give {
    width: 2.6rem !important;
    height: 2.6rem !important;
  }

  .chat_input i.give img {
    width: 1.4rem;
  }

  .submit input.text {
    height: 100%;
    flex: 1;
    font-size: 1.4rem;
  }

  .gift_list {
    transition: all .25s linear;
    height: 0;
    /* overflow: hidden; */
  }

  .gift_list>i {
    width: 6rem;
  }

  .demoCanvas {
    position: fixed;
    bottom: 11rem;
    left: 0;
    right: 0;
    height: 30rem;
    pointer-events: none;
  }

  .demoCanvasD {
    left: auto;
    right: 0;
    width: 30rem;
  }

  .demoCanvasA {
    left: 0;
    right: 5rem;
  }

  .gift_li.user_enter_li.flex_center {

    text-align: center;
    color: #fff;
    max-width: calc(100vw - 2rem);
    padding: .4rem 1rem;
    border-radius: .4rem;
    font-size: 1.4rem;
    animation: myfirstT 4.5s ease;
  }

  @keyframes myfirstT {
    0% {
      bottom: 0;
      opacity: 0;
    }

    20% {
      bottom: 4rem;
      opacity: .8;
    }

    100% {
      bottom: 16rem;
      opacity: 0;
    }
  }

  .gift_li.user_enter_li.flex_center>.user_enter_portrait {
    background-color: #fff;

  }

  .gift_li.user_enter_li.flex_center>span {
    display: inline-block;
    width: calc(100% - 5rem);
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .submit-btn {
    width: 5.2rem;
    border-radius: .5rem;
    overflow: hidden;
  }

  .popup_div {
    max-width: 80%;
    min-width: 60%;
  }

  .sign_button {
    position: fixed;
    bottom: 7rem;
    right: 2rem;
    flex-direction: column;
    font-size: 1rem;
    color: #333;
  }

  .sign_button>i {
    width: 2.5rem;
    height: 2.5rem;
    background: #F24D5B;
    border-radius: 50%;
    margin-bottom: .3rem;
  }

  .sign_button>i>img {
    width: 1.5rem;

  }

  /* 幸运观众 */
  .lucky_swiper {
    position: absolute;
    top: 4.2rem;
    width: 100%;
    left: 0;
    right: 0;
    height: 3rem;
    background: rgba(0, 0, 0, 0.1);
  }

  .lucky_swiper .swiper-slide {
    height: 100% !important;
  }

  .lucky_swiper .swiper-slide>i {
    width: 2rem;
    height: 2rem;
    border-radius: 50%;
    overflow: hidden;
    margin: 0 .4rem;
  }

  .lucky_swiper .swiper-slide>span {
    color: #ff0000;
  }

  .discuss_li_center{
-webkit-user-select: text;
-khtml-user-select: text;
-moz-user-select: text;
-ms-user-select: text;
 user-select: text;
  }
</style>


// WEBPACK FOOTER //
// src/components/minVideo/min_move.vue